{
	"page": {
		"pending": {
			"title": "Award medals",
			"subtitle": "{{games}}. Medal events whose medal meets are all official, oldest decision first. Review each podium, then award it."
		},
		"changed": {
			"title": "Changed since awarded",
			"subtitle": "{{games}}. Awarded events where a result or OVR's suggestion moved after the desk last settled the podium. Change it, or confirm it stands."
		},
		"noMedals": {
			"title": "No medals",
			"subtitle": "{{games}}. Medal events the desk settled with no medal: \"no medals\" decided, or every medal taken away. Open one to award its podium if that was a mistake."
		},
		"awarded": {
			"title": "Awarded medals",
			"subtitle": "{{games}}. Every awarded event, newest release first. Open one to check, correct or confirm its podium."
		}
	},
	"tabs": {
		"label": "Award medals lists",
		"pending": "To award",
		"changed": "Changed since awarded",
		"awarded": "Awarded",
		"noMedals": "No medals"
	},
	"dashboard": {
		"title": "Dashboard",
		"subtitle": "{{games}}. Where the medal events stand, and what waits for the desk.",
		"openAll": "Open the list",
		"more_one": "and {{n}} more",
		"more_other": "and {{n}} more"
	},
	"noGames": {
		"title": "No games yet",
		"body": "The medal desk opens once a games is set up in GMS."
	},
	"queue": {
		"loading": "Loading the queue…",
		"refreshing": "Refreshing",
		"retry": "Try again",
		"pages": "Queue pages",
		"previous": "Previous",
		"next": "Next",
		"pageOf": "Page {{page}} of {{pages}}",
		"keys": "Keys: ↓ or j next event, ↑ or k previous event.",
		"pending": {
			"title": "To award",
			"count_one": "{{n}} event waits for the desk",
			"count_other": "{{n}} events wait for the desk",
			"empty": "Nothing to award. Events appear here when every medal meet is official.",
			"decided": "Decided {{at}}",
			"ceremony": "Ceremony {{at}}",
			"hasSuggestion": "OVR suggested a podium",
			"official": "Official {{at}}",
			"awardBy": "Award by {{at}}"
		},
		"changed": {
			"title": "Changed since awarded",
			"count_one": "{{n}} awarded event to look at again",
			"count_other": "{{n}} awarded events to look at again",
			"empty": "Every awarded podium still matches its results and OVR's suggestion.",
			"results": "Results changed",
			"proposal_one": "OVR suggests otherwise ({{count}} athlete)",
			"proposal_other": "OVR suggests otherwise ({{count}} athletes)"
		},
		"noMedals": {
			"title": "Settled with no medals",
			"count_one": "{{n}} medal event with no medals",
			"count_other": "{{n}} medal events with no medals",
			"empty": "The desk has not settled any medal event with no medals.",
			"decided": "No medals since {{at}}",
			"decidedBy": "No medals since {{at}}, by {{name}}",
			"reason": "Reason: {{reason}}"
		},
		"search": "Search events",
		"bySport": "By sport",
		"emptyFiltered": "No event in this list matches the search or sport.",
		"awarded": {
			"title": "Awarded",
			"count_one": "{{n}} event awarded",
			"count_other": "{{n}} events awarded",
			"empty": "No event has been awarded yet.",
			"at": "Awarded {{at}}"
		}
	},
	"pane": {
		"loading": "Loading the event…",
		"retry": "Try again",
		"pickTitle": "Pick an event",
		"pickBody": "Choose an event from the queue to review its podium. Use j and k to move through the queue.",
		"openInOvr": "Open in OVR",
		"results": "Medal meets",
		"noMedalMeets": "This event has no medal meet yet.",
		"officialOf": "{{official}} of {{total}} official",
		"state": "Medals",
		"awarded": "Awarded",
		"notAwarded": "Not awarded yet",
		"noMedalsDecided": "No medals: the desk's decision",
		"locked": "Locked",
		"lastAward": "Last award",
		"lastReview": "Last desk decision",
		"reviewedBy": "{{at}} by {{name}}",
		"ceremony": "Medal ceremony",
		"lockedNote": "Locked: every result of this event is frozen, in OVR too. Changing a medal needs a reason.",
		"differsFromOvr": "The podium differs from OVR's suggestion:",
		"difference": "{{name}}: awarded {{awarded}}, OVR suggests {{proposed}}",
		"noMedal": "no medal",
		"deciding": "Deciding meet"
	},
	"suggestion": {
		"title": "OVR's suggestion",
		"fromOvr": "Sent by OVR from its official results. A suggestion only: the desk decides.",
		"computed": "OVR has not sent a suggestion yet. Shown here: what the official results point to, by the same rule OVR uses.",
		"none": "No suggestion yet: no medal meet has an official result.",
		"short": {
			"ovr": "Sent by OVR",
			"computed": "Not sent yet: computed from the official results",
			"none": "None yet"
		}
	},
	"editor": {
		"title": "Award the podium",
		"titleAwarded": "The podium",
		"subtitle": "Pick who gets each medal. Add a line for a tie or a second bronze; leave every line empty to decide no medals.",
		"medalOf": "Medal of line {{n}}",
		"whoOf": "Who gets this {{medal}} medal",
		"nobody": "Nobody",
		"remove": "Remove",
		"removeLine": "Remove line {{n}}",
		"add": "Add {{medal}}",
		"useSuggestion": "Use OVR's suggestion",
		"count": "{{medal}}: {{chosen}} of {{expected}} expected",
		"duplicate": "{{name}} is on two lines. A competitor gets one medal.",
		"notDecided": "Not every medal meet is official yet. You can still save, but check the results first.",
		"undo": "Undo changes",
		"noMedalsBody": "This event will award no medals. It leaves the queue until a medal meet is made official again, and is listed under No medals.",
		"action": {
			"award": "Award medals",
			"change": "Save changes",
			"confirm": "Confirm podium",
			"noMedals": "No medals"
		},
		"mismatch": {
			"title": "This podium does not match what the event expects",
			"line": "{{medal}}: {{chosen}} chosen, {{expected}} expected",
			"body": "Say why below, such as a tie or a dead heat. If a medal was left out, cancel and add it."
		},
		"hint": {
			"award": "The medals go to the tally and the portal at once.",
			"awardMismatch": "The medal counts differ from what the event expects: a reason is required.",
			"change": "A reason is required to change an awarded medal or its note.",
			"confirm": "Nothing changes. The desk records that the podium stands.",
			"noMedals": "A reason is required to decide that an event awards no medals."
		},
		"confirmTitle": {
			"award": "Award the medals of {{event}}?",
			"change": "Change the medals of {{event}}?",
			"confirm": "Confirm the podium of {{event}}?",
			"noMedals": "Award no medals in {{event}}?"
		},
		"saved": {
			"award": "Medals awarded.",
			"change": "Podium changed.",
			"confirm": "Podium confirmed.",
			"noMedals": "Recorded: no medals for this event."
		},
		"fillFromResults": "Fill from results",
		"noteOf": "Note on line {{n}}",
		"notePlaceholder": "Note on this medal (optional), e.g. photo finish",
		"ready_one": "{{n}} medal ready",
		"ready_other": "{{n}} medals ready"
	},
	"lock": {
		"lock": "Lock event",
		"unlock": "Unlock event",
		"lockTitle": "Lock this event?",
		"lockBody": "Every start list, result and meet of the event is frozen, in OVR too. Medals can still be corrected here, with a reason.",
		"unlockTitle": "Unlock this event?",
		"unlockBody": "OVR can change the event's results again.",
		"lockedToast": "Event locked.",
		"unlockedToast": "Event unlocked."
	},
	"reason": {
		"label": "Reason",
		"changePlaceholder": "e.g. Protest upheld: result corrected",
		"countPlaceholder": "e.g. Dead heat for bronze: both ranked 3rd",
		"noMedalsPlaceholder": "e.g. Only one finisher: no medals under the event rules",
		"unlockPlaceholder": "e.g. Protest on lane 6 to be heard"
	},
	"ceremony": {
		"label": "Medal ceremony time",
		"notSet": "Not set",
		"set": "Set time",
		"change": "Change",
		"save": "Save",
		"clear": "Clear",
		"cancel": "Cancel",
		"savedToast": "Ceremony time saved.",
		"clearedToast": "Ceremony time cleared."
	},
	"released": {
		"label": "Medal events decided",
		"decided": "of medal events decided ({{n}} of {{total}})",
		"detail": "{{awarded}} awarded · {{none}} with no medals · {{waiting}} waiting · {{medals}} medals released"
	},
	"ready": {
		"one": "{{event}} is ready to award.",
		"many_one": "{{count}} event is ready to award.",
		"many_other": "{{count}} events are ready to award.",
		"open": "Open"
	},
	"stage": {
		"label": "The podium being decided",
		"assign": "Assign {{medal}}",
		"captionAwarded": "The podium as it will be saved.",
		"captionDraft": "The podium being drafted."
	},
	"board": {
		"title": "Results",
		"subtitle": "The medal phases as the results stand. Choose G, S, B or — on a row to set that athlete's medal.",
		"empty": "No medal meet has results yet.",
		"showAll": "Show all {{n}}",
		"outcome": {
			"WIN": "Won",
			"LOSS": "Lost",
			"DRAW": "Drew",
			"BYE": "Bye"
		},
		"computed": "Results:",
		"computedTitle": "What the official results point to",
		"proposed": "OVR",
		"proposedTitle": "What OVR suggested",
		"showRoster": "Roster",
		"hideRoster": "Hide roster",
		"medalFor": "Medal for {{name}}",
		"noMedal": "No medal",
		"noRoster": "No roster on record.",
		"role": {
			"ATHLETE": "athlete",
			"RESERVE": "reserve",
			"GUIDE": "guide",
			"PILOT": "pilot",
			"COX": "cox"
		}
	},
	"history": {
		"title": "History",
		"subtitle": "Every award, change, note, review, ceremony time and lock, newest first.",
		"empty": "Nothing has been recorded for this podium yet.",
		"by": "by {{name}}",
		"system": "by the system",
		"reason": "Reason: {{reason}}",
		"awarded": "Awarded {{medal}} to {{name}}",
		"removed": "Took {{medal}} away from {{name}}",
		"aMedal": "a medal",
		"recoloured": "Changed {{name}} from {{from}} to {{to}}",
		"noted": "Note on {{name}}: {{note}}",
		"noteCleared": "Cleared the note on {{name}}",
		"reviewed": "Recorded the desk's decision",
		"ceremony": "Set the ceremony to {{at}}",
		"ceremonyCleared": "Cleared the ceremony time",
		"locked": "Locked the event",
		"unlocked": "Unlocked the event"
	}
}
